import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { AvailabilitySlotCalendarEvent, CalendarEventType } from '../../../types';

interface Props {
  event: AvailabilitySlotCalendarEvent;
}
export const AvailabilitySlotEvent = ({ event }: Props) => {
  return (
    <div data-event-type={'availabilitySlot' satisfies CalendarEventType} css={containerStyle}>
      {event.eventType}
    </div>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  borderRadius: theme.borderRadius.small,
  background: theme.colors.primary20,
  border: `1px solid ${theme.colors.primary50}`,
});
